import {
    clearAuthHeadersFromStorage,
    closeWebview,
    GlobalHeaderState,
    SwgyHeaderKeysList,
} from "@swiggy-private/checkout-core";
import { isMWebPlatform } from "@swiggy-private/core-ui";
import { isEmpty } from "@swiggy-private/js-utils";

export const getPreCartLinkFromStorage = () => {
    if (typeof window !== "undefined" && typeof window.sessionStorage !== "undefined") {
        try {
            const value = String(sessionStorage.getItem("swgy_mweb_static_web_food_cart_session_prev_link") || "");
            return value;
        } catch (_) {
            return "";
        }
    }
    return "";
};

export const handleEmptyCartOnLoad = () => {
    const platform = GlobalHeaderState.getHeader(SwgyHeaderKeysList.platform) || "";
    const isMweb = isMWebPlatform(platform);
    const preCartLink = getPreCartLinkFromStorage();

    if (isMweb && !isEmpty(preCartLink)) {
        clearAuthHeadersFromStorage();
        window.location.replace(preCartLink);
    } else {
        closeWebview();
    }
};
